import { Button, Modal, Space, Input, Form } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import React, { FC, useEffect } from 'react';
import { IModal } from 'common/models/model.interface';
import { FormWrapper } from 'common/components/form-wrapper/form-wrapper';
import { notification } from 'common/utils/notification';
import configurationStore from 'common/stores/configuration/configuration.store';

const PayEasePinModal: FC<IModal<any, any>> = ({ isOpen, onClose }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isOpen) {
      notification.destroy();
      form.resetFields();
    }
  }, [isOpen, form]);

  const hideModal = (...rest: any) => {
    notification.destroy();
    if (onClose) {
      onClose(...rest);
    }
  };

  const onFinish = ({ pin }: { pin: string }) => {
    const configuredPin = (configurationStore.configuration?.payEase?.pinCode ?? '').trim();
    const enteredPin = (pin ?? '').trim();

    if (configuredPin.length === 0 || enteredPin === configuredPin) {
      hideModal(true);
      return;
    }

    notification.error({ message: 'Invalid PIN. Please try again.' });
  };

  const handleOnKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      event.stopPropagation();
      form.submit();
    }
  };

  return (
    <div onKeyDown={handleOnKeyDown}>
      <Modal centered title="Enter PIN" width={362} open={isOpen} wrapClassName="custom-modal custom-modal--so" closable={false}>
        <FormWrapper form={form} onFinish={onFinish} layout="vertical">
          <Space className="full-width mb-12" size={8} direction="vertical">
            <Form.Item name="pin" label="Enter the EIQ-PayEase PIN to continue" rules={[{ required: true, message: 'PIN is required' }]}>
              <Input.Password autoFocus inputMode="numeric" maxLength={6} autoComplete="off" placeholder="Enter PIN" />
            </Form.Item>
          </Space>
          <Space className="footer">
            <Button className="eiq-button" type="link" onClick={() => hideModal(false)}>
              Cancel
            </Button>
            <Button type="primary" className="primary-btn eiq-button" icon={<LockOutlined />} onClick={() => form.submit()}>
              Continue
            </Button>
          </Space>
        </FormWrapper>
      </Modal>
    </div>
  );
};

export default React.memo(PayEasePinModal, (prevProps, nextProps) => {
  return prevProps.isOpen === nextProps.isOpen;
});
